import axiosInstance from './axiosInstance'

export interface SkyMobiAppItem {
  id: string
  name: string
  package_name: string
  configCount?: number
  createdAt?: string
  updatedAt?: string
}

export interface SkyMobiAppPayload {
  name: string
  package_name?: string
}

export class SkyMobiAppApi {
  static async getList(): Promise<SkyMobiAppItem[]> {
    const response = await axiosInstance.get('/cms/v1/sky-mobi-app')
    return response.data.data.list || []
  }

  static async getById(id: string): Promise<SkyMobiAppItem> {
    const response = await axiosInstance.get(`/cms/v1/sky-mobi-app/${id}`)
    return response.data.data.item
  }

  static async create(data: SkyMobiAppPayload): Promise<SkyMobiAppItem> {
    const response = await axiosInstance.post('/cms/v1/sky-mobi-app', data)
    return response.data.data.item
  }

  static async update(id: string, data: SkyMobiAppPayload): Promise<SkyMobiAppItem> {
    const response = await axiosInstance.put(`/cms/v1/sky-mobi-app/${id}`, data)
    return response.data.data.item
  }

  static async delete(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/sky-mobi-app/${id}`)
  }
}
